import fs from 'node:fs'
import path from 'node:path'
import { stringifyProjectJson } from '@core-engine/utils/json-format.js'
import type { InstalledPluginManifest } from '@plugin-engine/types.js'

function pluginsDir(cwd: string): string {
  return path.join(cwd, '.betterstart', 'plugins')
}

export function pluginManifestPath(cwd: string, pluginId: string): string {
  return path.join(pluginsDir(cwd), pluginId, 'manifest.json')
}

export function loadInstalledPluginManifest(
  cwd: string,
  pluginId: string
): InstalledPluginManifest | null {
  const filePath = pluginManifestPath(cwd, pluginId)
  if (!fs.existsSync(filePath)) {
    return null
  }

  return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as InstalledPluginManifest
}

export function saveInstalledPluginManifest(cwd: string, manifest: InstalledPluginManifest): void {
  const filePath = pluginManifestPath(cwd, manifest.id)
  fs.mkdirSync(path.dirname(filePath), { recursive: true })
  fs.writeFileSync(filePath, stringifyProjectJson(manifest), 'utf-8')
}

export function deleteInstalledPluginManifest(cwd: string, pluginId: string): void {
  fs.rmSync(path.dirname(pluginManifestPath(cwd, pluginId)), {
    recursive: true,
    force: true
  })
}
